import { useApplicationContext } from 'shared/utils/applicationContext';

interface INewbuildingBrokerMicrofrontFallbackModalSettings {
  title: string;
  description: string;
  buttonText: string;
  imageUrl?: string;
}

const DEFAULT_SETTINGS: INewbuildingBrokerMicrofrontFallbackModalSettings = {
  title: 'Что-то пошло не так',
  description: 'Повторите попытку',
  buttonText: 'Попробовать ещё раз',
};

export function useFallbackModalSettings(): INewbuildingBrokerMicrofrontFallbackModalSettings {
  const { config } = useApplicationContext();

  return (
    config.get<INewbuildingBrokerMicrofrontFallbackModalSettings>('newbuildingBroker.modalsMicrofrontFallback') ??
    DEFAULT_SETTINGS
  );
}
